import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=2bfd8133&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=2bfd8133&prod&scoped=true&lang=scss"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=2bfd8133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd8133",
  null
  
)

export default component.exports